<template>
  <div class="principal">
      <div class="container"  style="background:#fff;">
        <div class="row">
        <div class="imagemTrabalhista">         
          <img src="https://www.lefisc.com.br/calculos/static/img/logo.png" class="imgLogo">
          <div style="display: flex;    justify-content: center;">
            <h5 class="texto" style="width:600px;    font-style: italic;">Esta calculadora trabalhista auxilia na elaboração de cálculos frequentes na rotina do Departamento Pessoal.</h5>
          </div>
          <p class="texto" style="font-size:22px;">Escolha a opção abaixo que deseja calcular!</p>
          <div class="trianguloParaBaixo"></div>
        </div>
        </div>
        <div class="rowBloco">
           <div class="padrao" @click="irPaginaHorasExtras">
              <div class="ajus">
                <p class="textoBloco1" >Horas Extras</p>
                <div class="bolha">
                  <img src="../assets/arrow.svg" alt="">
                </div>
              </div>
              <div class="rodape">

              </div>
           </div>
           <div class="padrao" @click="irPaginaAdicionalNoturno">
             <div class="ajus">
                <p class="textoBloco1">Adicional Noturno</p>
                <div class="bolha"><img src="../assets/arrow.svg" alt=""></div>
              </div>
              <div class="rodape">

              </div>
           </div>
           <div class="padrao" @click="RemuneracaoFerias">
             <div class="ajus">
                <p class="textoBloco1">Remuneração de Férias</p>
                <div class="bolha"><img src="../assets/arrow.svg" alt=""></div>
              </div>
              <div class="rodape">

              </div>
           </div>
           <div class="padrao" @click="FaltasAfastamentos">
             <div class="ajus">
                <p class="textoBloco1">Férias: Faltas e Afastamento</p>
                <div class="bolha"><img src="../assets/arrow.svg" alt=""></div>
              </div>
              <div class="rodape">

              </div>
           </div>
           <div class="padrao" @click="RecisaoContrato">
             <div class="ajus">
                <p class="textoBloco1">Rescisão de Contrato de Trabalho</p>
                <div class="bolha"><img src="../assets/arrow.svg" alt=""></div>
              </div>
              <div class="rodape">

              </div>
           </div>
            <div class="padrao" @click="custo">
             <div class="ajus">
                <p class="textoBloco1">Custo do Empregado</p>
                <div class="bolha"><img src="../assets/arrow.svg" alt=""></div>
              </div>
              <div class="rodape">

              </div>
           </div>
                
           <div class="padrao" @click="CalculoAtestado">
             <div class="ajus">
                <p class="textoBloco1">Cálculo de Atestados</p>
                <div class="bolha"><img src="../assets/arrow.svg" alt=""></div>
              </div>
              <div class="rodape">

              </div>
           </div>

           <div class="padrao" @click="CalculoSeguroDesemprego">
             <div class="ajus">
                <p class="textoBloco1">Cálculo Seguro Desemprego</p>
                <div class="bolha"><img src="../assets/arrow.svg" alt=""></div>
              </div>
              <div class="rodape">

              </div>
           </div>
          
        </div>
      </div>
  </div>
</template>
<script>
export default {
  name: 'principal',
  data () {
    return {      
      arrow:'imgHover',
    }
  },
  methods:{
    custo(){
      this.atual = 6
        this.$router.push({
            name:'custoFuncionario',
            params:{id:6}
        })
    }, 
     RecisaoContrato(){
      this.atual = 5
        this.$router.push({
            name:'contratotrabalho',
            params:{id:5}
        })
    }, 
    irPaginaHorasExtras(){
      this.$router.push({
        name:'horasExtras',
        params:{id:1}
      })
    },
     irPaginaAdicionalNoturno(){
      this.$router.push({
        name:'adicionalNoturno',
        params:{id:2}
      })
    },
    RemuneracaoFerias(){  
          this.$router.push({
            name:'remuneracaoFerias',
            params:{id:3}
        })
    },
    FaltasAfastamentos(){  
          this.$router.push({
            name:'faltasAfastamentos',
            params:{id:4}
        })
    },
    CalculoAtestado(){
      this.$router.push({
            name:'calculoAtestado',
            params:{id:7}
        })
    },
    CalculoSeguroDesemprego(){
      this.$router.push({
            name:'calculoSeguroDesemprego',
            params:{id:8}
        })
    }
  },

  
}
</script>
<style scoped>

div.ajusteTamanho{
  padding:0px;
}
.textoCal{
  color: #383838;
  font-size:22px;
  font-weight: 300;
  padding-left:20px;
  padding-right:20px;
}

.imagemTrabalhista{
  width: 100%;
  height: 600px;
  background-image: url('https://www.lefisc.com.br/calculos/static/img/imgTra.jpg');
  padding-top:50px;
  background-size: cover;
}
.texto{
  color:#fff;margin-top:100px;
}
.trianguloParaBaixo {
  width: 0; 
  height: 0; 
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-top: 20px solid #fff;
  margin:20px auto;
}

</style>



// WEBPACK FOOTER //
// src/screens/Principal.vue